import { Component, ViewChild, ViewContainerRef, TemplateRef, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

import { Router } from '@angular/router';
import { Profile } from '../../../models/profilearray.model';
import { ArticlesService } from '../../../services/articles.service';
import { StorageProvider } from '../../../services/storage.provider';
import { InfoPopupComponent } from '../../../shared/components/infopopup/infopopup';
import { MetaProvider } from '../../../services/meta.provider';
import { GaEventTrackerProvider } from '../../../services/gaeventtracker.provider';
import { Multitenant } from '../../../services/multitenant.provider';
import { PopUp } from '../../../models/popup.model';

@Component({
  selector: 'app-createaccount3',
  templateUrl: 'createaccount3.html',
  styleUrls: ['createaccount3.scss']
})
export class CreateAccount3Page implements OnInit {
  @ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;
  @ViewChild('clone') clone: TemplateRef<any>;

  public model = new Profile([], [], '', '', '', [], '', 0, 0, '', []);
  public error: string;
  public error_coupon: string;
  public profiles: any = [1];
  public themeClass: string;
  public popup: PopUp = new PopUp();
  public tempPopUp: boolean;
  private access_token: string;


  constructor(
    private router: Router,
    private service: ArticlesService,
    public popoverCtrl: PopoverController,
    private storage: StorageProvider,
    private meta: MetaProvider,
    private ga: GaEventTrackerProvider,
    private multitenant: Multitenant
  ) {}
  ngOnInit(): void {
    this.themeClass = this.multitenant.getDomainClass();
    this.access_token = this.storage.getStorage('access_token');
    if (this.storage.getStorage('coupon')) {
      this.model.coupon[0] = this.storage.getStorage('coupon');
    }
  }

  ionViewDidEnter() {
    this.meta.clearHead();
  }

  createProfile(type?: string) {
    this.model.type = type;
    let profile: any;
    if (this.model.coupon[0]) {
      this.service.checkPormoCode(this.model.coupon[0]).subscribe({
        next:() => {
          this.model.firstName.forEach( (value, index, array) => {
            profile = {
              firstName: this.model.firstName[index],
              lastName: this.model.lastName[index],
              subscriber_number: this.model.subscriber_number[index],
              type: 'Children',
              coupon: this.model.coupon[index],
            };
            this.service.createProfilePost(profile, this.access_token).subscribe({
                next:() => this.ga.trackCouponEvent('Coupon sur nouveau compte', 'Validation du coupon', this.model.coupon[index].toString(), 0),
                error:() => this.error = ' Vos identifiants ne sont pas reconnus'
              });
          });
          this.router.navigate(['merci'], { queryParams: { page2: 'createprofils' } });
        },
        error:(error) => {
          this.error_coupon = error.message;
        }
      });
    } else {
      this.model.firstName.forEach( (value, index, array) => {
        profile = {
          firstName: this.model.firstName[index],
          lastName: this.model.lastName[index],
          subscriber_number: this.model.subscriber_number[index],
          type: 'Children',
          coupon: this.model.coupon[index],
        };
        this.service.createProfilePost(profile, this.access_token).subscribe({
          next:() => {},
          error:() => this.error = ' Vos identifiants ne sont pas reconnus'
        });
      });
      this.router.navigate(['merci'], { queryParams: { page2: 'createprofils' } });
    }
  }

  cloneTemplate() {
    const forms = this.profiles.length;
    if (forms <= 4) {
      this.profiles.push(1);
    } else {
      alert('On peut pas ajouter plus de 5 profils');
    }
  }

  isLogin(): string {
    return 'login';
  }

  async presentPopover2(myEvent) {
    const popover = this.popoverCtrl.create({
      component: InfoPopupComponent,
      componentProps: { page: 'step2-numeroabo' },
      cssClass: 'password-tooltip'
    });
    (await popover).present(myEvent);
  }

  async presentPopover3(myEvent) {
    const popover = this.popoverCtrl.create({
      component: InfoPopupComponent,
      componentProps: { page: 'step3-promocode' },
      cssClass: 'password-tooltip'
    });
    (await popover).present(myEvent );
  }

  changeHandler() {
    if (!this.model.coupon[0]) {
      this.error_coupon = '';
    }
  }

  showTempPopUp() {
    this.tempPopUp = true;
    this.popup.type = 'devoir';
    this.popup.data = this.themeClass;
  }
  onNotifyPopUp(message: string): void {
    this.tempPopUp = false;
  }
}
